import { render, staticRenderFns } from "./ChipsSelection.vue?vue&type=template&id=644916a4&scoped=true"
import script from "./ChipsSelection.vue?vue&type=script&lang=js"
export * from "./ChipsSelection.vue?vue&type=script&lang=js"
import style0 from "./ChipsSelection.vue?vue&type=style&index=0&id=644916a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644916a4",
  null
  
)

export default component.exports